<template>
  <div style="height: 100vh;background: #0782B8;">
    <div class="machine-head">
      <div>{{ row.title }}  {{ row.saiqu_name }}</div>
      <div>{{ row.subject_name }}</div>
    </div>

    <table class="machine-table" :style="'height:' + (clientHeight -104 - 50 -20) + 'px; overflow-y: auto;' ">
      <thead>
      <tr>
        <th>排名</th>
        <th>队伍名称</th>
        <th>分数</th>
      </tr>
      </thead>
<!--      <tbody :style="'height:' + (clientHeight  -104 - 50 - 20) + 'px; overflow-y: scroll;' ">-->
      <tbody :style="'height:' + (clientHeight  -104 - 50 - 20) + 'px; overflow-y: scroll;' ">
      <tr v-for="(item, index) in scoreList" :key="item.id">
        <td>{{ item.rank }}</td>
        <td>{{ item.mingcheng }}</td>
        <td>
          {{item.score_total}}
        </td>
      </tr>
      </tbody>

    </table>
  </div>
</template>
<style>
body {
  overflow-y: hidden;
}

.machine-table {
  width: 100%;
  color: #E3E59D;
}

table th, table td {
  height: 50px;
  font-size: 16px;
  /*text-align: center;*/
  /*border: 1px solid gray;*/
}

table td a {
  color: #E3E59D;
}

table td a:hover {
  color: #F2EB92;
  text-decoration: underline;
}

table td a.disabled {
  color: #999;
}
table td a.disabled:hover {
  cursor: default;
  text-decoration: none;
}

table thead {
  color: white;
  background-color: #0782B8;
}

table tbody {
  display: block;
  /*width: calc(100% + 8px); !*这里的8px是滚动条的宽度*!*/
  height: 300px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

table thead tr, table tbody tr, table tfoot tr {
  box-sizing: border-box;
  table-layout: fixed;
  display: table;
  width: 100%;
}

::-webkit-scrollbar {
  width: 0px;
  background-color: transparent;
}

table thead th:first-child {
  width: 100px;
  text-align: center;
}

table tbody td:first-child {
  text-align: center;
  width: 100px;
}

table thead th:last-child, table tbody td:last-child {
  padding-right: 40px;
  width: 100px;
  text-align: left;
}

table tbody td:last-child {
  font-size: 16px;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
}


table thead th:nth-child(2) {
  /*width: 400px;*/
}

table tbody td:nth-child(2) {
  /*width: 400px;*/
}

/*table thead th:nth-child(3) {*/
/*  width: 360px;*/
/*}*/

/*table tbody td:nth-child(3) {*/
/*  width: 360px;*/
/*}*/

table thead th:nth-child(4) {
  width: 100px;
}

table tbody td:nth-child(4) {
  width: 100px;
}
/*table thead th:first-child, table tbody td:first-child{*/
/*  padding-left: 30px;*/
/*}*/

table tbody tr:nth-child(odd) {
  background: #196586;
}

.pointer {
  cursor: pointer;
}

.machine-head {
  /*background: url("../../assets/icon-machine-bg.png") no-repeat;*/
  /*background-size: 100% 205px;*/
  /*height: 205px;*/
  padding: 13px 0;
  text-align: center;
  font-size: 26px;
  color: #fff;
  font-weight: 500;
  background: #0782B8;
  border-bottom: 1px solid #fff
}

.machine-content {
  margin: 30px 30px 0;
}

.machine-content-left {
  width: 75%;
}

.machine-content-operate {
  display: flex;
  flex-wrap: wrap;
}

.machine-li {
  width: 20%;
  text-align: center;
}

.machine-li-box {
  margin: 0 10px 10px 0;
  background: #fff;
  overflow: hidden;
  border-radius: 10px;
}

.caipan-info {
  padding: 10px 0;
  cursor: pointer;
}

.caipan-info-disabled {
  background: #EEEEEE;
}

.caipan-name {
  font-weight: 500;
  color: #4A4A4A;
}

.caipan-score {
  font-size: 30px;
  font-weight: 500;
  color: #000;
  font-family: DINAlternate-Bold, DINAlternate;
}

.caipan-comment {
  color: #9B9B9B;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.caipan-button {
  padding: 0 5px;
  height: 35px;
  width: 100%;
}

.caipan-button-active {
  background: #1F85E2;
}

.caipan-button-score {
  background: #0EB791;
  cursor: pointer;
}

.caipan-button-disabled {
  background: #9B9B9B;
}

.caipan-button-li {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  height: 35px;
  cursor: pointer;
  color: #fff;
}

.caipan-machine-li {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  color: #fff;
  height: 35px;
  cursor: pointer;
}

.caipan-button-li img, .caipan-machine-li img {
  width: 14px;
  margin-right: 5px;
}

</style>
<script>
import qs from 'qs'
import {
  getStartMachineRankList,
  getScoreRankList,
  setScore,
  setSubjectStatus,
  setCurrent,
  scoreCommentOptions,
  setCaipanStatus, zhixuceCreate, zhixuceDownload, createRankBook
} from '@/api/dscore'
import {sjsqOptions, subjectOptions} from '@/api/sai'
import EditableCell from '@/components/EditableCell/'
import moment from 'moment'
import setting from "../../config/setting";

export default {
  name: 'ScoreStartMachineSubjectRank',
  components: {
    EditableCell
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      drawerVisible: false,
      scoreVisible: false,
      rankVisible: false,
      dataVisible: false, // 修改数据
      currentFilter: false,
      currentCpIndex: 0,
      // tableHeight:document.documentElement.clientHeight-180,
      // tableHeight:300,
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperColNew: {
        xs: {span: 24},
        sm: {span: 12},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
      form: this.$form.createForm(this),
      row: {
      },

      queryParam: {
        keywords: '',
        showScore: 1, // 只显示有分数的
        subjectRow: '',
        sjsq: [],
      },

      scoreList: [],
      clientHeight: 0
    }

  },
  mounted() {
    const that = this

    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`          //document.body.clientWidth;

    document.title = '项目排名'

    // 获取数据
    that.fetch()

    // 换成轮询
    that.timer = setInterval(function () {
      that.fetch()
    }, 2000)
  },
  destroyed() {
    // 销毁监听
    // this.socket.close()
    clearInterval(this.timer)
  },
  computed: {},
  methods: {
    moment,
    fetch() {
      //刷新数据
      const that = this

      getStartMachineRankList({
        id: that.$route.query.id || 0,
        subject: that.$route.query.subject,
      }).then(res => {
        that.row = res.data.row
        that.scoreList = res.data.list
      }).catch(err => {
        that.$message.error(err.data.msg)
      })
    },

    // 格式化数据
    formatData(data) {
      const that = this
      that.scoreList = data.list
      that.row = data.row

      that.queryParam.sjsq = [1, data.row.saiqu]

      // 定义 比赛总时间规则
      that.row.sai_time_total = data.row.sai_time_total ? data.row.sai_time_total : '00:00:00'
      that.caipan = data.caipan

      data.caipan.map(row => {
        if (row.type == '裁判') {
          if (row.jgroup == 0) {
            that.caipanListA.push(row)
          } else {
            that.caipanListB.push(row)
          }
        }

        if (row.type == '裁判长') {
          that.caipanAdmin = row
        }

      })

      // 获取参赛队伍 信息
      that.getSubjectRow()
      // console.log(that.caipanListA, that.caipanListB)
    },

    // 获取单只队伍详情
    getSubjectRow() {
      let that = this,
          index = that.currentIndex,
          list = that.scoreRankList,
          caipanList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
          rank = 0, //名次
          subjectRow = that.subjectRow = that.scoreList[index],
          caipan = !subjectRow.jgroup || subjectRow.jgroup == 0 ? that.caipanListA : that.caipanListB

      that.sTime = subjectRow.stime

      list.map((row) => {
        if (row.id == that.subjectRow.id) {
          rank = row.rank_value
        }
      })
      that.subjectRow.rank = rank

      // console.log('scoreList22', caipan,that.caipanListA, that.caipanListB)

      // 根据index 设置裁判位置
      // vue的双向绑定导致 defaultCaipanList值发生变化 循环时重置为预设的10个裁判位
      caipanList.map((item, scoreIndex) => {
        caipan.map((row) => {
          if (scoreIndex == row.index) {
            caipanList[scoreIndex] = row ? row : ''
          }
        })
      })

      // 运行的timer丢失
      that.getListTimer()

      that.caipan = caipanList
      console.log("getSubjectRow", that.subjectRow, caipanList, that.scoreList)

      // 获取排名信息
      // that.getRankList(that.subjectRow.subject)

      that.drawerVisible = false
    },

    getRankList(subject) {
      let that = this

      that.queryParam.subjectRow = subject
      getScoreRankList({
        id: that.formData.id,
        subject: subject
      }).then(res => {
        that.scoreRankList = res.data.list
        that.row.sai_time_total = res.data.time_total


        // 需要是数组
        let arr = subject.split('.'),
            data = []

        arr.map((row, index) => {
          let dataRow = ''
          for (var i = 0; i <= index; i++) {
            dataRow += arr[i] + '.'
          }

          dataRow = dataRow.substr(0, dataRow.length - 1)
          data.push(dataRow)
        })

        console.log(subject, arr, data)
        that.subjectQuery = data

        // that.subjectQuery = ['CLUB2021FENZHANSAI11','CLUB2021FENZHANSAI11.1','CLUB2021FENZHANSAI11.1.1' ,'CLUB2021FENZHANSAI11.1.1.7']
      }).catch(err => {
        that.$message.error(err.data.msg)
      })
    },

    createRankBook() {
      let that = this;
      let query = {}
      query.sjsq = that.queryParam.sjsq
      query.subjects = [that.queryParam.subjectRow]
      createRankBook(query).then(res => {
        that.$message.success('生成成功')
      }).catch(err => {
        that.$message.error(err.data.msg);
      })
    },

    download(type) {
      let that = this;
      switch (type) {
        case 1:
          window.open(setting.apiBaseURL + '/adminapi/dscore/rankListDownload?' + qs.stringify(that.queryParam));
          break;
      }
    },

    handleOpenArmy(record) {
      window.open('ScoreStartMachineArmy?subject_id='+record.id)
    },

    handleOpenRank(record) {
      window.open('ScoreStartMachineRank?subject_id='+record.id)
    },

    handleOpenSubjectRank(record) {
      window.open('ScoreStartMachineSubjectRank?subject_id='+record.id)
    },

    // 选择评语
    onCommentSelect(content) {
      this.scoreComment = content
    },

    // 开始比赛
    handleSetCurrent(current_index) {
      const that = this

      that.scoreList.map(item => {
        item.current = false
      })
      that.scoreList[current_index].current = true

      setCurrent({
        id: that.formData.id,
        current_index: current_index
      }).then(res => {
        // 通知所有普通裁判
        let data = {
          id: that.formData.id
        }
        // let val = that.formatSocketInfo('sai_start', '', data)
        // this.socket.send(val)

        // tha
        that.drawerVisible = false
        that.$message.success('开始比赛')
        that.currentIndex = that.currentSubjectIndex = res.data.current_index;

      }).catch(err => {
        that.$message.error(err.data.msg);
      })
    },

    handleRank() {
      let that = this
      that.rankVisible = true

      that.getSubjectOptions()
    },


    getSubjectOptions() {
      let that = this;
      subjectOptions({saiqu: that.row.saiqu}).then(res => {
        that.subjectOptions = res.data
      });
      that.getRankList(that.subjectRow.subject)
    },

    // 查询排名
    onSubjectChange(value) {
      let endValue = this.subjectFilterValue = value[value.length - 1],
          list = this.mingdanOldLeftList

      console.log('onSubjectChange', value, endValue, list)
      // this.getRankList(endValue)
    },

    onSubjectSearch() {
      let endValue = this.subjectFilterValue
      if (!endValue) endValue = this.subjectRow.subject
      this.getRankList(endValue)
    },

    onScoreValueChange(value) {
      console.log("onScoreValueChange", value)
    },

    // 操作分数
    onScoreOperate(index) {
      const that = this
      that.caipanIndex = index
      that.scoreVisible = true

      console.log("onScoreOperate", index, that.scoreValue)

      that.scoreValue = that.scoreList[that.currentIndex]['score' + that.caipanIndex]
      that.scoreComment = that.scoreList[that.currentIndex]['comment' + that.caipanIndex]
      console.log('onScoreOperate')
      that.getCommentList()
    },

    getCommentList() {
      let that = this
      console.log("getCommentList")
      scoreCommentOptions().then(res => {
        that.commentList = res.data
      }).catch(err => {
        console.log('--错误--');
      })
    },

    // 重新设置分数
    onResetScoreChange(record, score_index, value, content = '') {
      console.log('score'.score_index);
      let that = this
      record['score' + score_index] = value
      setScore({
        id: record.id,
        score_index: score_index,
        score: value,
        content: content
      }).then(res => {
        that.$message.success('设置成功')
        that.scoreVisible = false

      }).catch(err => {
        console.log('--错误--');
        record['score' + err.data.data.score_index] = err.data.data.score;
        that.$message.error(err.data.msg);
      })
    },

    onDataChange(record, index, value) {
      let that = this
      console.log(record['score' + index])
      that.onScoreChange(record, index, value, record['comment' + index])
    },

    // 打分
    onScoreChange(record, score_index, value, content = '') {
      console.log('score'.score_index, record);

      let that = this
      record['score' + score_index] = value
      setScore({
        id: record.id,
        score_index: score_index,
        score: value,
        content: content
      }).then(res => {
        that.$message.success('打分成功')
        that.scoreVisible = false

        that.fetch()
      }).catch(err => {
        console.log('--错误--');
        record['score' + err.data.data.score_index] = err.data.data.score;
        that.$message.error(err.data.msg);
      })
    },

    // 存储分数
    onScoreSave() {
      let that = this,
          scoreValue = that.scoreValue,
          record = that.scoreList[that.currentIndex],
          scoreComment = that.scoreComment

      console.log(record, that.currentIndex, that.currentSubjectIndex)

      if (record.status === 2) {
        this.$message.error('当前队伍比赛已完成')
        return
      } else if (record.index != that.currentSubjectIndex) {
        this.$message.error('当前队伍尚未开始比赛')
        return
      }

      scoreValue = scoreValue == undefined ? 0 : scoreValue
      that.onScoreChange(record, that.caipanIndex, scoreValue, scoreComment)
    },

    // 切换下一支队伍
    onSubjectNext() {
      let that = this,
          index = that.currentIndex
      that.currentIndex = parseInt(index) + 1

      that.getSubjectRow()
    },

    // 切换指定队伍
    onSubjectCurrent(index) {
      let that = this
      that.currentIndex = index

      that.getSubjectRow()
    },

    // 切换上一支队伍
    onSubjectPrev() {
      let that = this,
          index = that.currentIndex
      that.currentIndex = index - 1

      that.getSubjectRow()
    },

    submitForm() {
    },

    //比赛弃权
    onSubjectStatusChange(status) {
      let that = this

      setSubjectStatus({
        id: that.subjectRow.id,
        status: status
      }).then(res => {
        that.$message.success('操作成功');

        // 刷新当前状态
        that.fetch()

        // let type = 'score_submit'
        // if (status === 3) type = 'sai_giveup'
        //
        // let data = {
        //   'id': that.row.id
        // }
        // let val = that.formatSocketInfo(type, '', data)
        //
        // that.socket.send(val)
      }).catch(err => {
        console.log('--错误--');
        that.$message.error(err.data.msg);
      })
    },

    // 重新打分
    onReSetScore(record, indexOld) {
      // 通知所有裁判 将分数置为0
      // console.log(record)
      let that = this,
          index = indexOld + 1
      this.onResetScoreChange(that.scoreList[that.currentIndex], index, 0, that.scoreList[that.currentIndex]['comment' + index])

      // let data = {}
      // let val = that.formatSocketInfo('score_reset', record.num, data)
      // this.socket.send(val)
    },

    // 手动下线
    onLoginOut(record) {
      // console.log(record)
      // 更改状态 通知客户端
      let that = this

      // 兼容客户端直接退出的情况
      setCaipanStatus({
        id: that.row.id,
        num: record.num
      }).then(res => {
        let data = {
          'id': that.row.id
        }

        that.fetch()

        // let val = that.formatSocketInfo('caipan_logout', record.num, data)
        // that.socket.send(val)

      }).catch(err => {
        console.log('--错误--');
      })
    },

    // 超时自动下线
    onLoginOutAuto(record) {
      // console.log(record)
      // 更改状态 通知客户端
      let that = this

      // 兼容客户端直接退出的情况
      setCaipanStatus({
        id: that.row.id,
        num: record.num
      }).then(res => {
        that.fetch()
      }).catch(err => {
        console.log('--错误--');
      })
    },

    init: function () {
      if (typeof (WebSocket) === "undefined") {
        alert("您的浏览器不支持socket")
      } else {
        // 实例化socket
        let that = this
        this.socket = new WebSocket(setting.wsBaseURL)
        // 监听socket连接
        this.socket.onopen = this.open
        // 监听socket错误信息
        this.socket.onerror = this.error
        // 监听socket消息
        this.socket.onmessage = this.getMessage

        this.socket.onclose = function (e) {
          // that.reconnect()
          console.log('websocket 断开：' + e.code + ' ' + e.reason + ' ' + e.wasClean)
        }
      }
    },
    open: function () {
      // console.log('heartStart',this.row)
      this.heartStart()
      this.heartCheck()
    },
    error: function () {
      console.log("连接错误")
      // this.reconnect()
    },
    getMessage: function (msg) {
      // console.log('getMessage', msg.data)
      let data = JSON.parse(msg.data),
          that = this


      // 判断在数组中
      let typeList = ['caipan_login', 'caipan_logout', 'score_submit', 'time_update']

      console.log('typeList.includes(data.type)', typeList.includes(data.type), data)
      if (typeList.includes(data.type) && that.formData.id == data.data.id) {
        that.fetch()
      }

      return;

      switch (data.type) {

          /**
           * caipan_login  名称：裁判登录， 刷新对象：裁判长
           * caipan_logout 名称：裁判退出， 刷新对象：裁判长刷新
           * score_submit  名称：裁判提交分数 刷新对象：裁判长刷新
           * time_update ，名称：时间更新 刷新对象：裁判长刷新
           *
           * score_reset ，名称：普通裁判重新打分 刷新对象：指定的普通裁判刷新
           * sai_start  名称：开始评分， 刷新对象：普通裁判
           * sai_complete 名称：评分完成， 刷新对象：仲裁
           * sai_giveup 名称：弃权， 刷新对象：仲裁
           */


        case 'caipan_common' :
          // 普通裁判登录 打分等
          //  if(id=='') 当前场次
          this.fetch()
          break
        case 'caipan_common_logout' :
          // 普通裁判下线 执行状态更改
          this.onLoginOutAuto(data) //delete
          break
        default:
          console.log('default')
      }
    },
    send: function (params) {
      this.socket.send(params)
    },
    close: function () {
      console.log("socket已经关闭")
    },

    heartStart() {
      let that = this

      let token = that.caipanAdmin.num,
          data = {}

      let val = that.formatSocketInfo('heart_start', token, data)
      that.socket.send(val)
    },

    heartCheck() {
      let that = this;
      that.heartTimer = setInterval(function () {

        let token = that.caipanAdmin.num,
            data = {
              'id': that.formData.id
            }

        let val = that.formatSocketInfo('heart_check', token, data)
        that.socket.send(val)
      }, 8000)
    },

    formatSocketInfo(type, token, data) {
      return JSON.stringify({
        'type': type,
        'token': token,
        'data': data,
      })

    },

    reconnect() {
      let that = this,
          lockReconnect = that.lockReconnect,
          tt = that.timer

      // 重连
      if (lockReconnect) return
      lockReconnect = true
      //没连接上会一直重连，设置延迟避免请求过多
      tt && clearTimeout(tt)
      that.timer = setTimeout(function () {
        that.init()
        lockReconnect = false
      }, 4000)

    },

    getTimeSecond(time) {
      if (!time) {
        return '00:00:00'
      }
      var hour = time.split(':')[0]
      var min = time.split(':')[1]
      var sec = time.split(':')[2]
      var s = Number(hour * 3600) + Number(min * 60) + Number(sec)

      // console.log(hour, min, sec, Number(min * 60), Number(sec * 60))

      // console.log(time+ '-----' + s)
      return s
    },

    // 格式化为时间字符串
    // minute 添加的时间
    formatTimeToTime(time, minute = 0) {
      // let time = '03:58:00',
      //     minute = 3,
      let date = '',
          today = new Date(new Date().setHours(0, 0, 0, 0)).getTime()

      // 如何得到 03:33:00

      var hour = time.split(':')[0]
      var min = time.split(':')[1]
      var sec = time.split(':')[2]
      var s = Number(hour * 3600) + Number(min * 60) + Number(minute * 60) + Number(sec)

      let endTime = s * 1000 + today

      date = this.formatDate(endTime, 'h:m:s')
      // console.log('formatTimeToTime', min,endTime, date)

      return date
    },

    formatDate(num, format) {
      const formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
      const returnArr = [];
      const date = new Date(num);
      returnArr.push(date.getFullYear()); // 取得4位数的年份
      returnArr.push(this.formatNumber(date.getMonth() + 1)); // 取得日期中的月份，其中0表示1月，11表示12月
      returnArr.push(this.formatNumber(date.getDate())); // 返回日期月份中的天数（1到31）
      returnArr.push(this.formatNumber(date.getHours())); // 返回日期中的小时数（0到23）
      returnArr.push(this.formatNumber(date.getMinutes())); // 返回日期中的分钟数（0到59）
      returnArr.push(this.formatNumber(date.getSeconds())); // 返回日期中的秒数（0到59）

      for (const i in returnArr) {
        // 判断对象是否含有某个非继承属性
        if ({}.hasOwnProperty.call(returnArr, i)) {
          format = format.replace(formateArr[i], returnArr[i]); // 替换
        }
      }
      return format;
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : `0${n}`;
    },
  }
}
</script>
